export default "//yastatic.net/s3/distribution/pythia/frontend/_/ada7e2a0dd1cb46c4934fdfe954456ac.png";